import { render } from "./InfoDetail.vue?vue&type=template&id=52b915a3&scoped=true"
import script from "./InfoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoDetail.vue?vue&type=script&setup=true&lang=js"

import "./InfoDetail.vue?vue&type=style&index=0&id=52b915a3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b915a3"],['__file',"src/containers/logs/logCollections/components/LogMetricInfo/InfoDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52b915a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52b915a3', __exports__)) {
    api.reload('52b915a3', __exports__)
  }
  
  module.hot.accept("./InfoDetail.vue?vue&type=template&id=52b915a3&scoped=true", () => {
    api.rerender('52b915a3', render)
  })

}


export default __exports__